<template>
  <div class="top-banner" v-if="isHome && isTopBanner">

    <swiper
      class="swiper bannerSwiper"
      ref="bannerSwiper"
      :slidesPerView="1"
      :spaceBetween="0"
      :initialSlide="0"
      :loop="true"
      :autoplay="{
          delay: 4000,
          disableOnInteraction: false,
      }"
      :modules="modules"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide class="swiper-slide">
        <button  type="button" class="banner grade" @click="goGrade">
          <img src="@/assets/images/icon/grade.png" class="icon" alt="고객등급제" />
          <span>혜택도 프리미엄답게, <strong class="text-yellow">NEW 고객등급제!</strong></span>
        </button>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <button  type="button" class="banner kakao" v-if="authStore.isLogin" @click="goKakao">
          <img src="@/assets/images/icon/kakao.png" class="icon" alt="카카오톡" />
          <span>카카오톡 친구는 <strong class="text-yellow">1만원 혜택!</strong></span>
        </button>
        <button type="button" class="banner welcome" v-else @click="goWelcome">
          <img src="@/assets/images/icon/welcome.png" class="icon" alt="100원" />
          <span>신규회원은 <strong class="text-yellow">드시모네 100원</strong></span>
        </button>
      </swiper-slide>
    </swiper>
    <button type="button" class="close" @click="isTopBanner = false">
      <img src="@/assets/images/ico_close_white_thin.svg" alt="닫기">
    </button>
  </div>
  <div class="layout-header">
    <div v-if="rootStore.headerTitle.type === 1">
      <keep-alive>
        <HomeTitle v-if="isMobileWeb() || isMobileApp()" />
      </keep-alive>
      <LeftMenu />
    </div>
    <div v-else-if="rootStore.headerTitle.type === 2">
      <AppEventTitle 
      @clickBack="rootStore.headerBackFunc" 
      />
    </div>
    <div v-else-if="rootStore.headerTitle.type === 3">
      <AppStoreTitle 
      @clickBack="rootStore.headerBackFunc" 
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import LeftMenu from '@/components/store/LeftMenu.vue';
import HomeTitle from '@/components/HomeTitle.vue';
import AppEventTitle from '@/components/event/AppTitle.vue';
import AppStoreTitle from '@/components/store/AppTitle.vue';

import { isMobileApp, isMobileWeb } from '@/utils/common';

import { Swiper, SwiperSlide } from 'swiper/vue'
import { Swiper as SwiperClass, Pagination, Navigation, Autoplay } from "swiper";
import 'swiper/css'
import "swiper/css/pagination";
import 'swiper/css/navigation';

const modules = reactive([Pagination, Navigation, Autoplay])
const onSwiper = (swiper: SwiperClass) => {}
const onSlideChange = (swiper: SwiperClass) => {}

const store = useMainStore();
const rootStore = useRootStore();
const authStore = useAuthStore();

const route = useRoute()
const isHome = ref(false)
const isClient = ref(false);

watch(
  () => authStore.authToken,
  async (newVal) => {
    updateCartCount();
  }
);

watch(
  () => route.path, 
  async (newPath, oldPath) => {
    console.log("newPath ::::: ", newPath);

    // 홈 여부 판단
    isHome.value = (newPath === '/' || newPath === '/main');

    //페이지 이동시 처리 작업
    if (newPath !== oldPath) {
      console.log('oldPath::::::::::::', oldPath);
      console.log('newPath:::::::::::: ', newPath);

      await nextTick(); 
      console.log('스크롤 위치11111::::', window.scrollY);

      // 클라이언트에서만 동작
      setTimeout(() => {
        if (isClient.value && typeof window !== 'undefined') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          console.log('스크롤 위치2222222::::', window.scrollY);
        }
      }, 300); 

      isTopBanner.value = true;
    }
  },
  { immediate: true } // 페이지 로드 시에도 즉시 실행
);


onMounted(async () => {
  isClient.value = true;
  updateCartCount();
});

const goGrade = (): void => {
  navigateTo('/event/membership');
};

const goKakao = () => {
  navigateTo('/event/event42');
};

const goWelcome = () => {
  navigateTo('/welcome');
};

const closeTop = () => {
  isHome.value = false
};

const isTopBanner = ref(true);
</script>